import i18n from "../i18nt/index";

// export const BASE_PAGE = "/";
// export const LOGIN_PAGE = "/login";
// export const REGISTER_PAGE = "/register";
// export const FORGOT_PASSWORD_PAGE = "/forgot-password";
// export const HOME_PAGE = "/";
// export const ERROR_PAGE = "/error-page";
// export const NOT_FOUND_PAGE = "/not-found";
export const AUTH_CALLBACK_PAGE = "/api/auth/:provider/callback";

export type PageInfo = {
  route?: string;
  title: string;
  nestedRoutes?: { [key: string]: PageInfo };
  i18nKey: string;
};

export const PAGES: { [key: string]: PageInfo } = {
  BASE: {
    route: "/",
    title: i18n.t("pages.home.title"),
    i18nKey: "pages.home.title",
  },
  HOME: {
    route: "/",
    title: i18n.t("pages.home.title"),
    i18nKey: "pages.home.title",
  },
  LICENSE: {
    route: "/licence",
    title: i18n.t("pages.licence.title"),
    i18nKey: "pages.license",
  },
  CONTACT: {
    route: "/kontakt",
    title: i18n.t("pages.contact.title"),
    i18nKey: "pages.contact",
  },
  ABOUT: {
    route: "/o-nama",
    title: i18n.t("pages.about.title"),
    i18nKey: "pages.about",
  },
  SERVICE: {
    title: i18n.t("pages.service"),
    i18nKey: "pages.service",
  },
  WORK_SAFETY_HEALTH: {
    route: "/usluge/bezbednost-i-zdravlje-na-radu",
    title: i18n.t("pages.workSafetyHealth.title"),
    i18nKey: "pages.workSafetyHealth",
  },
  SITE_SAFETY_COORDINATOR: {
    route: "/usluge/koordinator-za-bezbednost-i-zdravlje-na-radu",
    title: i18n.t("pages.siteSafetyCoordinator.title"),
    i18nKey: "pages.siteSafetyCoordinator",
  },
  ENERGY_EFFICIENCY: {
    route: "/usluge/energetska-efikasnost",
    title: i18n.t("pages.energyEfficiency.title"),
    i18nKey: "pages.energyEfficiency",
  },
  GEO_INFRA_MONITORING: {
    route: "/usluge/monitoring",
    title: i18n.t("pages.geoInfraMonitoring.title"),
    i18nKey: "pages.geoInfraMonitoring",
  },
  SUPERVISION: {
    route: "/usluge/nadzor",
    title: i18n.t("pages.supervision.title"),
    i18nKey: "pages.supervision",
  },
  PREDICTIVE_MAINTENANCE: {
    route: "/usluge/prediktivno-odrzavanje-objekata",
    title: i18n.t("pages.predictiveMaintenance.title"),
    i18nKey: "pages.predictiveMaintenance",
  },
  DESIGN: {
    route: "/usluge/projektovanje",
    title: i18n.t("pages.design.title"),
    i18nKey: "pages.design",
  },
  FIRE_PROTECTION: {
    route: "/usluge/zastita-od-pozara",
    title: i18n.t("pages.fireProtection.title"),
    i18nKey: "pages.fireProtection",
  },
  ENVIRONMENTAL_PROTECTION: {
    route: "/usluge/zastita-zivotne-sredine",
    title: i18n.t("pages.environmentalProtection.title"),
    i18nKey: "pages.environmentalProtection",
  },
  /*STANDARDIZATION: {
    route: "/service/standardization",
    title: i18n.t("pages.standardization.title"),
    i18nKey: "pages.standardization",
  },*/
  FIRST_AID: {
    route: "/usluge/prva-pomoc",
    title: i18n.t("pages.firstAid.title"),
    i18nKey: "pages.firstAid",
  },
  PROFESSIONAL_TRAINING: {
    route: "/usluge/strucno-osposobljavanje-zaposlenih-obuke",
    title: i18n.t("pages.professionalTraining.title"),
    i18nKey: "pages.professionalTraining",
  },
  INSPECTIONS_TESTING: {
    route: "/usluge/pregledi-i-ispitivanja",
    title: i18n.t("pages.inspectionsTesting.title"),
    i18nKey: "pages.inspectionsTesting",
  },
};
